<template>
	<div class="selected_merchant d_flex justify_end">
		<div class="d_flex align_items_center">
			<span class="icon_language"></span>
		</div>
		<div class="d_flex align_items_center">
			<select v-model="s_locale_code" id="select_language">
				<option v-for="item in locales" :value="item.code" :key="item.code">
					{{ item.name }}
				</option>
			</select>
		</div>
	</div>
	<div class="login_wrap">
		<div class="logo_box">
			<img src="@/assets/images/logo.png" alt="logo" />
		</div>
		<div class="login_area">
			<h2>{{ $t('merchant_management.payment_list.login') }}</h2>
			<form v-on:submit.prevent="loginBtnClick">
				<input
					type="text"
					class="mb_16"
					:placeholder="$t('auth.id')"
					v-model="user.user_id"
				/>
				<input
					type="password"
					:placeholder="$t('auth.password')"
					v-model="user.password"
				/>
				<button class="merchant_button bg_black">
					{{ $t('merchant_management.payment_list.login') }}
				</button>
			</form>

			<div class="link">
				<router-link to class="mb_8 fc_red" @click="toSignup">{{
					$t('button.signup')
				}}</router-link>
				<router-link :to="{ name: 'auth-find-account' }">{{
					$t('merchant_management.payment_list.forgot')
				}}</router-link>
			</div>
		</div>
	</div>
	<ModalViewM
		v-if="modalMerchant"
		add-class="merchant"
		@closeModal="modalMerchant = false"
	>
		<template #title>
			<h3 class="modal_title_m mb_16">
				{{ $t('merchant_management.payment_list.merchant_selection') }}
			</h3>
		</template>
		<MerchantPickerM @selectMerchant="selectMerchant"></MerchantPickerM>
	</ModalViewM>
</template>

<script>
import store from '@/store/store';
import ModalViewM from '@/components/Layout/ModalView.m';
import MerchantPickerM from '@/components/Merchant/MerchantPicker.m';
import { mapState } from 'vuex';
export default {
	name: 'Login',
	components: {
		ModalViewM,
		MerchantPickerM,
	},
	data() {
		return {
			modalMerchant: false,
			user: {
				user_id: '',
				password: '',
				otp_token: '',
			},
		};
	},
	computed: {
		...mapState('common', ['locales']),
		s_locale_code: {
			get() {
				return this.$store.state.common.locale;
			},
			set(value) {
				this.$store.dispatch('common/setLocale', value);
			},
		},
		is_logged_in() {
			return store.getters.is_logged_in;
		},
	},
	methods: {
		toSignup() {
			this.$router.push({ name: 'auth-register' });
		},
		async validation() {
			if (!this.user.user_id) alert(this.$t('alert.request_id'));
			else if (!this.user.password) alert(this.$t('alert.request_pw'));
			else return true;
		},
		loginBtnClick() {
			this.validation().then(result => {
				if (!result) return false;
				else this.loginHandler(this.user);
			});
		},
		loginHandler(user) {
			this.loading = true;
			store
				.dispatch('auth/login', user)
				.then(result => {
					if (result?.otp_token_required) {
						this.otpTokenRequired = result.otp_token_required;
					} else {
						// location.href = this.$router.resolve({
						// 	name: 'auth-dashboard',
						// }).href;
						this.modalMerchant = true;
					}
				})
				.catch(error => {
					this.message =
						(error.response &&
							error.response.data &&
							error.response.data.message) ||
						error.message ||
						error.toString();
					alert(this.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		selectMerchant(obj) {
			this.toRoute(obj);
			this.$store.dispatch('auth/getMerchantInfo', obj.params.merchant_seq);
			this.modalMerchant = false;
		},
		toRoute(obj) {
			this.$router.push(obj);
		},
	},
};
</script>

<style scoped></style>
